import api from "./axios";
import type { ChangeTariffPayload } from "@/struct/TariffStruct";

export default class TariffService {
  changeTariff = (payload: ChangeTariffPayload) => {
    return api.post("/api/ems/tariff-swap", {
      mainProductId: payload.mainProductId,
      scheduledOn: payload.scheduledOn,
    });
  };
  getOffers = async () => {
    return api.get("/api/web-api/customer/get-offers");
  };
  getSubscriptionDetails = () => {
    return api.get("/api/ems/get-subscription-details");
  };
}
